import React, {Component} from 'react'
import {connect} from 'react-redux'
import AppContentComponent from '../../../templates/content'
import DatePicker from 'material-ui/DatePicker';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import LinearProgress from 'material-ui/LinearProgress';
import {CSVLink} from 'react-csv';
import {getPromotion} from "../../../../api/promotions";

import Select from 'react-select';


import {app} from "../../../../config/constants";
import {api} from "../../../../api";
import {withRouter, Link} from 'react-router-dom';
import axios from "axios/index";
import {config} from "../../../../config";

class AppStatisticsCompareComponent extends Component {
	constructor(props) {
		super(props);

		this.handleFilterChange = this.handleFilterChange.bind(this);
		this.handleFilterChangeArray = this.handleFilterChangeArray.bind(this);
		this.loadData = this.loadData.bind(this);
		this.setPromotionCampaignName = this.setPromotionCampaignName.bind(this);
		this.setPromotionCampaignType = this.setPromotionCampaignType.bind(this);
		this.setPromotionCampaignSubject = this.setPromotionCampaignSubject.bind(this);
		this.setPromotionCampaignDepartment = this.setPromotionCampaignDepartment.bind(this);
		this.setPromotionType = this.setPromotionType.bind(this);
		this.setPromotionPeriods = this.setPromotionPeriods.bind(this);
		this.setPromotionVariants = this.setPromotionVariants.bind(this);
		this.setPromotionIsActive = this.setPromotionIsActive.bind(this);
		this.setFilterOptions = this.setFilterOptions.bind(this);

		this.setPositionFilter = this.setPositionFilter.bind(this);
		this.setCampaignsFilter = this.setCampaignsFilter.bind(this);
		this.setStartDateFilter = this.setStartDateFilter.bind(this);
		this.setEndDateFilter = this.setEndDateFilter.bind(this);
		this.setActiveFilter = this.setActiveFilter.bind(this);
		this.setTypeFilter = this.setTypeFilter.bind(this);
		this.setSubjectFilter = this.setSubjectFilter.bind(this);
		this.setDepartmentFilter = this.setDepartmentFilter.bind(this);
		this.setCompanyFilter = this.setCompanyFilter.bind(this);
		this.setSideAdFilter = this.setSideAdFilter.bind(this);
		this.setUniquelyLinkedFilter = this.setUniquelyLinkedFilter.bind(this);

		this.getCsvData = this.getCsvData.bind(this);

		this.downloadCsv = this.downloadCsv.bind(this);
		this.closeDialog = this.closeDialog.bind(this);
		this.setPostIds = this.setPostIds.bind(this);

		this.filterOnPosition = this.filterOnPosition.bind(this);

		this.filterActive = this.filterActive.bind(this);

		this.state = {
			userSettings           : {
				columns: []
			},
			userSettingsInitialized: false,
			downloadingCsvProgress : 0,
			downloadingCsv         : false,
			showMoreFilters        : false,
			promotions             : [],
			promotionsToShow       : [],
			campaigns              : [],
			types                  : [],
			subjects               : [],
			departments            : [],
			companies              : [],
			periods                : [],
			variants               : [],
			csvData                : [],
			loading                : false,
			filters                : {
				active        : null,
				campaigns     : null,
				startDate     : null,
				endDate       : null,
				// startDate     : new Date( '2018-12-01' ),
				// endDate       : new Date( '2018-12-31' ),
				position      : null,
				type          : null,
				subject       : null,
				department    : null,
				company       : null,
				sideAdPosition: null,
				uniquelyLinked: null,
				postIds       : {},
			},
			filterOptions          : {
				positions      : [],
				campaigns      : [],
				sideAdPositions: [
					{
						value: 'c1',
						label: 'Commercieel 1',
					},
					{
						value: 'c2',
						label: 'Commercieel 2',
					},
					{
						value: 'c3',
						label: 'Commercieel 3',
					},
					{
						value: 'c4',
						label: 'Commercieel 4',
					},
					{
						value: 'r1',
						label: 'Redactioneel 1',
					},
					{
						value: 'r2',
						label: 'Redactioneel 2',
					},
					{
						value: 'r3',
						label: 'Redactioneel 3',
					},
					{
						value: 'r4',
						label: 'Redactioneel 4',
					},
					{
						value: 'cta1',
						label: 'Anchor CTA 1',
					},
					{
						value: 'cta2',
						label: 'Anchor CTA 2',
					},
					{
						value: 'cta3',
						label: 'Anchor CTA 3',
					},
				],
				uniquelyLinked : [
					{
						label: 'Ja',
						value: true,
					},
					{
						label: 'Nee',
						value: false,
					},
				],
				active         : [
					{
						label: 'Actief',
						value: true,
					},
					{
						label: 'Niet actief',
						value: false,
					},
				],
				types          : [],
				subjects       : [],
				departments    : [],
				companies      : [],
			}
		}
	}

	getPosts(input, callback) {
		let cancel;

		if (input.length < 4) {
			return;
		}

		return axios.get(config.postSearch.url + '?s=' + input,)
			.then((response) => {
				return new Promise((resolve, reject) => {
					let i = 0;
					let options = [];

					if (response.data.length > 0) {
						response.data.map((item) => {

							let obj = {
								ID        : item.ID,
								post_title: `${item.post_title} - ${item.ID}`
							};

							options.push(obj);

							if (options.length === response.data.length) {
								resolve(options);
							}
						})
					} else {
						resolve(options);
					}


				}).then(options => {
					return {
						options: options
					};

				})
			})
	}

	setPostIds(value) {
		this.setState({
			filters: {
				...this.state.filters,
				postIds: value
			}
		}, () => {
			this.filterResults();
		});
	}

	componentDidMount() {
		this.setup()
	}

	componentDidUpdate(prevProps) {
		if (prevProps.match.params.type !== this.props.match.params.type) {
			this.setup();
		
			const interval = setInterval(() => {
				if (!this.state.loading) {
					const dataTable = document.getElementsByClassName('promotion__data')[0];
		
					if (dataTable && typeof dataTable.getElementsByTagName === 'function') {
						const childs = dataTable.getElementsByTagName('tr');
		
						for (let i = 0; i < childs.length; i++) {
							childs[i].classList.remove('promotion__data__row--hidden');
						}
		
						clearInterval(interval);
					}
				}
			}, 100);
		}
		

		if (undefined !== this.props.user.uid && false === this.state.userSettingsInitialized) {
			api.settings.user.getSettings(this.props.user.uid).then(response => {
				if (null !== response.val()) {
					this.setState({
						userSettings           : response.val(),
						userSettingsInitialized: true
					});
				}
			});
		}

	}

	setup() {
		this.loadData().then(async () => {
			await this.setPromotionCampaignName();


			await this.setPromotionCampaignType();
			await this.setPromotionCampaignSubject();
			await this.setPromotionCampaignDepartment();
			await this.setPromotionCampaignCompany();
			await this.setPromotionType();
			await this.setPromotionPeriods();
			await this.setPromotionVariants();
			await this.setPromotionIsActive();

			this.setState({
				promotionsToShow: this.state.promotions
			});

			await this.setFilterOptions();

			this.filterResults();
		});
	}

	componentWillMount() {
	}

	filterPosition(promotion) {
		if (null === this.state.filters.position) {
			return true;
		}

		return promotion.position === this.state.filters.position.value;
	}


	filterActive(promotion) {

		if (null === this.state.filters.active) {
			return true;
		}

		return promotion.isActive === this.state.filters.active.value;
	}

	filterUniquelyLinked(promotion) {

		if (null === this.state.filters.uniquelyLinked) {
			return true;
		}

		return promotion.uniquelyLinked === this.state.filters.uniquelyLinked.value;
	}

	filterCampaign(promotion) {
		if (null === this.state.filters.campaigns) {
			return true;
		}

		const campaign = this.state.filters.campaigns.filter(function (campaign) {
			return campaign.value === promotion.campaign;
		});

		return campaign.length > 0;
	}

	filterType(promotion) {
		if (null === this.state.filters.type) {
			return true;
		}

		return promotion.type.key === this.state.filters.type.value;
	}

	filterSubject(promotion) {
		if (null === this.state.filters.subject) {
			return true;
		}

		return promotion.subject.key === this.state.filters.subject.value;
	}

	filterDepartment(promotion) {
		if (null === this.state.filters.department) {
			return true;
		}

		return promotion.department.key === this.state.filters.department.value;
	}

	async setPromotions() {
		let i = 0;
		let allPromotions = [];

		this.setState({
			loading: true,
		});

		return new Promise((resolve, reject) => {
			app.database().ref('/cams/promotions/promotions').once('value', async (promotionsSnap) => {
				const getArchived = 'archived' === this.props.match.params.type;

				return new Promise((resolve, reject) => {
					promotionsSnap.forEach((promotion) => {
						if (
							(
								false === getArchived && (undefined === promotion.val().archived || false === promotion.val().archived)
							) ||
							(
								true === getArchived && undefined !== promotion.val().archived && true === promotion.val().archived
							)
						) {
							allPromotions.push({
								key                  : promotion.key,
								name                 : promotion.val().name,
								position             : promotion.val().position,
								campaignKey          : promotion.val().campaign,
								campaignName         : '-',
								campaignType         : '-',
								campaignTypeKey      : '',
								campaignDepartment   : '-',
								campaignDepartmentKey: '',
								campaignCompany      : '-',
								campaignCompanyKey   : '',
								promotionType        : '-',
								views                : '-',
								clicks               : '-',
								ctr                  : 0,
								periods              : [],
								start                : (promotion.val().startDateTimeStamp !== undefined ? promotion.val().startDateTimeStamp : false),
								end                  : (promotion.val().endDateTimeStamp !== undefined ? promotion.val().endDateTimeStamp : false),
								active               : false,
								status               : 'ended',
								sideAdPosition       : promotion.val().sideAdPosition !== undefined ? promotion.val().sideAdPosition : false,
								uniquelyLinked       : promotion.val().postIds !== undefined && promotion.val().postIds.length !== 0,
								linkedTo             : promotion.val().postIds !== undefined && promotion.val().postIds.length !== 0 ? promotion.val().postIds : [],
							});
						}

						if (++i === promotionsSnap.numChildren()) {
							resolve(allPromotions);
						}
					});
				}).then(promotions => {
					promotions = promotions.reverse();

					this.setState({
						promotions      : promotions,
						promotionsToShow: promotions,
						loading         : false,
					}, () => {
						resolve();
					});
				})
			});
		});
	}

	async setCampaigns() {
		let i = 0;
		let allCampaigns = [];
		return new Promise((resolve, reject) => {
			app.database().ref('cams/campaigns').once('value', (campaignsSnap) => {
				return new Promise((resolve, reject) => {
					campaignsSnap.forEach((campaign) => {
						allCampaigns.push({
							key       : campaign.key,
							title     : campaign.val().title,
							type      : campaign.val().type,
							department: campaign.val().department,
							subject   : campaign.val().subject,
							company   : campaign.val().company,
							archived  : (
								undefined !== campaign.val().archived && true === campaign.val().archived
							)
						});

						if (++i === campaignsSnap.numChildren()) {
							resolve(allCampaigns);
						}
					});
				}).then(campaigns => {
					this.setState({
						campaigns: campaigns
					}, () => {
						resolve();
					});
				})
			});
		})
	}

	async loadCompanies() {
		let i = 0;
		let retCompanies = [];

		return new Promise((resolve, reject) => {
			this.state.campaigns.forEach(campaign => {
				if ('' !== campaign.company) {
					app.database().ref('cams/companies').child(campaign.company).once('value', companySnap => {
						const company = this.state.companies.find(company => {
							return company.key === companySnap.key
						});

						if (undefined === company) {
							this.setState({
								companies: [
									...this.state.companies,
									{
										key : companySnap.key,
										data: companySnap.val()
									}
								]
							});
						}

						if (++i === this.state.campaigns.length) {
							resolve();
						}
					});
				} else if (++i === this.state.campaigns.length) {
					resolve();
				}

			});
		})
	}

	setCampaignSettings(setting) {
		let i = 0;
		let allSettings = [];

		return new Promise((resolve, reject) => {
			app.database().ref('cams/settings/campaigns/' + setting).once('value', (settingsSnap) => {
				return new Promise((resolve, reject) => {
					settingsSnap.forEach((type) => {
						allSettings.push({
							key : type.key,
							name: type.val().name
						});

						if (++i === settingsSnap.numChildren()) {
							resolve(allSettings);
						}
					})
				}).then(settings => {
					this.setState({
						[setting]: settings,
					}, () => {
						resolve();
					})
				})

			})
		})
	}

	getPeriods() {
		let i = 0;
		let allPeriods = [];

		return new Promise((resolve, reject) => {
			app.database().ref('cams/promotions/periods').once('value', (periodsSnap) => {
				return new Promise((resolve, reject) => {
					periodsSnap.forEach((period) => {
						allPeriods.push({
							key        : period.key,
							promotionId: period.val().promotionID,
							start      : period.val().startDateTimeStamp,
							end        : period.val().endDateTimeStamp,
						});

						if (++i === periodsSnap.numChildren()) {
							resolve(allPeriods);
						}
					})
				}).then(periods => {
					this.setState({
						periods: periods,
					}, () => {
						resolve();
					})
				})
			})
		})
	}

	getVariants() {
		let i = 0;
		let allVariants = [];

		return new Promise((resolve, reject) => {
			app.database().ref('cams/promotions/variants').once('value', (variantsSnap) => {
				return new Promise((resolve, reject) => {
					variantsSnap.forEach((variant) => {
						allVariants.push({
							key      : variant.key,
							periodKey: variant.val().periodId,
							active   : variant.val().active
						})

						if (++i === variantsSnap.numChildren()) {
							resolve(allVariants);
						}
					})
				}).then(variants => {
					this.setState({
						variants: variants,
					}, () => {
						resolve()
					})
				})
			})
		})
	}

	loadData() {
		this.setState({
			promotions: [],
			csvData   : []
		});

		return new Promise(async (resolve, reject) => {
			await this.setPromotions();
			await this.setCampaigns();
			await this.setCampaignSettings('types');
			await this.setCampaignSettings('subjects');
			await this.setCampaignSettings('departments');
			await this.loadCompanies();
			await this.getPeriods();
			await this.getVariants();

			resolve();
		});
	}

	handleFilterChangeArray(name, value) {
		this.setState({
			...this.state,
			filters: {
				...this.state.filters,
				[name]: value
			}
		}, () => {
			this.loadData();
		});
	}

	handleFilterChange(name, value) {
		this.setState({
			...this.state,
			filters: {
				...this.state.filters,
				[name]: value
			}
		}, () => {
			this.loadData();
		});
	}

	setPromotionCampaignName() {
		let i = 0;
		let {promotions} = this.state;
		let allPromotions = [];

		return new Promise((resolve, reject) => {
			const promotionsPromise = this.state.promotions.map((promotion, index) => {
				const campaign = this.state.campaigns.find((campaign, key) => {
					return promotion.campaignKey === campaign.key;
				});

				if (undefined !== campaign) {
					return {
						...promotions[index],
						campaignName: campaign.title
					};
				} else {
					return promotions[index];
				}
			});

			Promise.all(promotionsPromise).then(promotions => {
				this.setState({
					promotions: promotions
				}, () => {
					resolve();
				})
			});
		})
	}

	setPromotionCampaignType() {
		let i = 0;
		let {promotions} = this.state;
		let allPromotions = [];

		return new Promise((resolve, reject) => {
			const promotionsPromise = this.state.promotions.map((promotion, index) => {
				const campaign = this.state.campaigns.find((campaign, key) => {
					return promotion.campaignKey === campaign.key;
				});

				if (undefined !== campaign) {

					const type = this.state.types.find((type, key) => {
						return campaign.type === type.key
					});

					if (undefined !== type) {

						return {
							...promotions[index],
							campaignType   : type.name,
							campaignTypeKey: type.key
						};
					} else {
						return promotions[index];
					}
				}
			});

			Promise.all(promotionsPromise).then(promotions => {
				this.setState({
					promotions: promotions
				}, () => {
					resolve();
				});
			});

		})

	}

	async setPromotionCampaignSubject() {
		const { promotions, campaigns, subjects } = this.state;
	
		const updatedPromotions = await Promise.all(promotions.map(async (promotion, index) => {
			if (promotion && promotion.campaignKey) {
				const campaign = campaigns.find(campaign => promotion.campaignKey === campaign.key);
	
				if (campaign) {
					const subject = subjects.find(subject => campaign.subject === subject.key);
	
					if (subject) {
						return {
							...promotion,
							campaignSubject: subject.name,
							campaignSubjectKey: subject.key
						};
					}
				}
			}
	
			// If promotion is undefined or promotion.campaignKey is undefined or no matching campaign is found
			return promotion;
		}));
	
		this.setState({
			promotions: updatedPromotions,
		});
	
		return Promise.resolve();
	}
	
	

	setPromotionCampaignDepartment() {
		let { promotions } = this.state;
	
		return new Promise((resolve, reject) => {
			const promotionsPromise = this.state.promotions.map((promotion, index) => {
				if (promotion && promotion.campaignKey) {
					const campaign = this.state.campaigns.find(campaign => promotion.campaignKey === campaign.key);
	
					if (campaign) {
						const department = this.state.departments.find(obj => campaign.department === obj.key);
	
						if (department) {
							return {
								...promotions[index],
								campaignDepartment: department.name,
								campaignDepartmentKey: department.key
							};
						}
					}
				}
	
				// If promotion.campaignKey is undefined or no matching campaign is found
				return promotions[index];
			});
	
			Promise.all(promotionsPromise).then(promotions => {
				this.setState({
					promotions: promotions,
				}, () => {
					resolve();
				});
			});
		});
	}
	

	setPromotionCampaignCompany() {
		let { promotions } = this.state;
	
		return new Promise((resolve, reject) => {
			const promotionsPromise = this.state.promotions.map((promotion, index) => {
				if (promotion && promotion.campaignKey) {
					const campaign = this.state.campaigns.find(campaign => promotion.campaignKey === campaign.key);
	
					if (campaign) {
						const company = this.state.companies.find(obj => campaign.company === obj.key);
	
						if (company && company.data && company.data.title) {
							return {
								...promotions[index],
								campaignCompany: company.data.title,
								campaignCompanyKey: company.key
							};
						}
					}
				}
	
				// If promotion.campaignKey is undefined or no matching campaign is found
				return promotions[index];
			});
	
			Promise.all(promotionsPromise).then(promotions => {
				this.setState({
					promotions: promotions,
				}, () => {
					resolve();
				});
			});
		});
	}
	
	
	setPromotionType() {
		let { promotions } = this.state;
	
		return new Promise((resolve, reject) => {
			const promotionsPromise = this.state.promotions.map((promotion, index) => {
				if (promotion && promotion.position !== undefined) {
					const type = api.promotions.types.find(type => promotion.position === type.value);
	
					if (type) {
						return {
							...promotions[index],
							promotionType: type.title,
							promotionTypeKey: type.value
						};
					}
				}
	
				// If promotion.position is undefined or no matching type is found
				return promotions[index];
			});
	
			Promise.all(promotionsPromise).then(promotions => {
				this.setState({
					promotions: promotions,
				}, () => {
					resolve();
				});
			});
		});
	}
	
	setPromotionPeriods() {
		let i = 0;
	
		return new Promise((resolve, reject) => {
			let { promotions } = this.state;
			const promotionsPromise = this.state.promotions.map((promotion, index) => {
				// Find the periods for this promotion
	
				let promotionPeriods = [];
	
				if (promotion && promotion.key) {
					for (const period of this.state.periods) {
						if (period.promotionId === promotion.key) {
							promotionPeriods.push(period);
						}
					}
				}
	
				if (promotionPeriods.length > 0) {
					return {
						...promotions[index],
						periods: promotionPeriods
					};
				} else {
					return {
						...promotions[index],
						periods: [],
					};
				}
			});
	
			Promise.all(promotionsPromise).then(promotions => {
				this.setState({
					promotions: promotions,
				}, () => {
					resolve();
				});
			});
		});
	}
	

	setPromotionVariants() {
		let i = 0;
		let promotionVariants = [];

		return new Promise((resolve, reject) => {
			let {promotions} = this.state;

			const promotionsPromise = this.state.promotions.map((promotion, index) => {
				let promotionVariants = [];

				for (const period of promotion.periods) {
					for (const variant of this.state.variants) {
						if (variant.periodKey === period.key) {
							promotionVariants.push(variant);
						}
					}
				}

				if (promotionVariants.length > 0) {
					return {
						...promotion,
						variants: promotionVariants
					};
				} else {
					return {
						...promotion,
						variants: []
					};
				}
			});

			Promise.all(promotionsPromise).then(promotions => {
				this.setState({
					promotions: promotions,
				}, () => {
					resolve();
				})
			})
		});
	}

	setPromotionIsActive() {
		let {promotions} = this.state;

		return new Promise((resolve, reject) => {
			const promotionsPromise = this.state.promotions.map((promotion, index) => {
				let active = false;
				let status = 'ended';
				const currentTime = Date.now();

				if (promotion.position === 'branded') {
					if (promotion.start < currentTime && (promotion.end === false || promotion.end === 0 || promotion.end === undefined || promotion.end > currentTime)) {
						active = true;
					}
				} else {
					const search = promotion.periods.find((period) => {
						return period.start < currentTime && (period.end === 0 || period.end === undefined || period.end > currentTime);
					});

					if (undefined !== search) {
						status = 'active';

						let {variants} = promotion;

						variants = variants.filter(variant => {
							return search.key === variant.periodKey && true === variant.active;
						});

						if (variants.length > 1) {
							status = 'testing';
						}

						if ((0 !== search.end && undefined !== search.end) && (((search.end - currentTime) / 1000) < 253200)) {
							status = 'ending';
						}

						active = true;
					} else {

						const planned = promotion.periods.find(period => {
							return period.start > currentTime;
						});

						if (undefined !== planned) {
							status = 'planned';
						}

					}
				}

				return {
					...promotions[index],
					active: active,
					status: status
				};
			});

			Promise.all(promotionsPromise).then(promotions => {
				this.setState({
					promotions: promotions,
				}, () => {
					resolve();
				})
			})
		})

	}

	getPromotionViews(key) {
		return new Promise((resolve, reject) => {
			if (null === this.state.filters.startDate || null === this.state.filters.endDate) {
				app.database().ref('cams/statistics/simple/views').child(key).on('value', (viewsSnap) => {
					if (null === viewsSnap.val()) {
						resolve(0);
					} else {
						resolve(viewsSnap.val().views);
					}
				})
			} else {
				// Let the "fun" begin...
				let viewsCount = 0;
				const step = 86400000;
				const endTime = this.state.filters.endDate.getTime() + 86400000;
				const startTime = this.state.filters.startDate.getTime();

				for (let i = startTime; i <= endTime; i += step) {
					const date = new Date(i);
					const year = date.getFullYear();
					const month = date.getMonth();
					const day = date.getDate();

					app.database().ref('cams/statistics/detailed/views/' + key + '/' + year + '/' + month + '/' + day).once('value', (viewsSnap) => {
						let j = 0;
						if (viewsSnap.numChildren() === 0 && (i + step >= endTime)) {
							resolve(viewsCount);
						}

						viewsSnap.forEach((view) => {
							viewsCount += view.val().v;

							if (i + step >= endTime && ++j === viewsSnap.numChildren()) {
								resolve(viewsCount);
							}
						});
					});
				}
			}
		});
	}


	getPromotionClicks(key) {
		return new Promise((resolve, reject) => {
			if (null === this.state.filters.startDate || null === this.state.filters.endDate) {
				app.database().ref('cams/statistics/simple/clicks').child(key).on('value', (clicksSnap) => {
					if (null === clicksSnap.val()) {
						resolve(0);
					} else {
						resolve(clicksSnap.val().clicks);
					}
				})
			} else {
				// Let the "fun" begin...
				let clicksCount = 0;
				const step = 86400000;
				const endTime = this.state.filters.endDate.getTime() + 86400000;
				const startTime = this.state.filters.startDate.getTime();

				for (let i = startTime; i <= endTime; i += step) {
					const date = new Date(i);
					const year = date.getFullYear();
					const month = date.getMonth();
					const day = date.getDate();

					app.database().ref('cams/statistics/detailed/clicks/' + key + '/' + year + '/' + month + '/' + day).once('value', (clicksSnap) => {
						let j = 0;
						if (clicksSnap.numChildren() === 0 && (i + step >= endTime)) {
							resolve(clicksCount);
						}

						clicksSnap.forEach((view) => {
							clicksCount += view.val().c;

							++j;

							if (i + step >= endTime && j === clicksSnap.numChildren()) {
								resolve(clicksCount);
							}
						});
					});
				}
			}
		});


	}

	async getPromotionStatistics(promotion) {
		let views = 0;
		let clicks = 0;


		if (promotion.position === 'branded') {
			views += await this.getPromotionViews(promotion.key);
			clicks += await this.getPromotionClicks(promotion.key);
		} else {
			if ( promotion.variants ) {
				for (const variant of promotion.variants) {
					views += await this.getPromotionViews(variant.key);
					clicks += await this.getPromotionClicks(variant.key);
				}
			}
		}

		return Promise.resolve({
			views : views,
			clicks: clicks,
			ctr   : (0 !== views && clicks !== 0 ? ((clicks / views) * 100).toFixed(2) : 0)
		});

	}

	async loadPromotionStatistics(promotion) {
		const stats = await this.getPromotionStatistics(promotion);

		this.setState({
			promotionsToShow: [
				...this.state.promotionsToShow.map((setPromotion) => {
					if (setPromotion.key !== promotion.key) {
						return setPromotion;
					}

					return {
						...setPromotion,
						views : stats.views,
						clicks: stats.clicks,
						ctr   : stats.ctr
					}
				})
			]
		});
	}

	async getCsvData() {
		let i = 0;
		const onePercent = 100 / this.state.promotionsToShow.length;

		for (const promotion of this.state.promotionsToShow) {
			const stats = await this.getPromotionStatistics(promotion);

			this.setState({
				downloadingCsvProgress: onePercent * ++i,
				csvData               : [
					...this.state.csvData,
					{
						active    : (promotion.active === true ? 'Ja' : 'Nee'),
						name      : promotion.name,
						campaign  : promotion.campaignName,
						type      : promotion.campaignType,
						subject   : promotion.campaignSubject,
						department: promotion.campaignDepartment,
						position  : promotion.promotionType,
						views     : stats.views,
						clicks    : stats.clicks,
						ctr       : stats.ctr,
					}
				]
			})
		}
	}


	setFilterOptions() {
		return new Promise(resolve => {
			const positionsPromise = api.promotions.types.map((type) => {
				return {
					label: type.title,
					value: type.value
				}
			});

			const campaignsPromise = this.state.campaigns.map((campaign) => {
				if (!campaign.archived) {
					return {
						label: campaign.title,
						value: campaign.key,
					};
				}

				return null;
			});

			const typesPromise = this.state.types.map((type) => {
				return {
					label: type.name,
					value: type.key
				};
			})

			const departmentsPromise = this.state.departments.map((department) => {
				return {
					label: department.name,
					value: department.key
				}
			})

			const subjectsPromise = this.state.subjects.map((subject) => {
				return {
					label: subject.name,
					value: subject.key
				}
			});

			const companiesPromise = this.state.companies.map((company) => {
				if (company && company.data && company.data.title) {
					return {
						label: company.data.title,
						value: company.key
					};
				} else {
					// Handle the case where company.data.title is null or undefined
					return {
						label: 'Default Label', // Replace with your default value or handle accordingly
						value: company.key
					};
				}
			});
			
			Promise.all([positionsPromise, campaignsPromise, typesPromise, departmentsPromise, subjectsPromise, companiesPromise]).then(values => {
				this.setState({
					filterOptions: {
						...this.state.filterOptions,
						positions  : values[0],
						campaigns  : values[1].filter(campaign => campaign !== null),
						types      : values[2],
						departments: values[3],
						subjects   : values[4],
						companies  : values[5],
					}
				}, () => {
					resolve();
				});
			})
		})
	}

	filterResults() {
		this.setState({
			promotionsToShow: this.state.promotions
		}, async () => {
			await this.filterOnPosition();
			await this.filterOnCampaign();
			await this.filterOnDate();
			await this.filterOnActive();
			await this.filterOnType();
			await this.filterOnSubject();
			await this.filterOnDepartment();
			await this.filterOnCompany();
			await this.filterOnSideAdPosition();
			await this.filterOnUniquelyLinked();
			await this.filterOnPostID();
		});
	}

	setPositionFilter(value) {
		this.setState({
			...this.state,
			filters: {
				...this.state.filters,
				position: value
			}
		}, () => {
			this.filterResults();
		});

		// this.props.handleFilterChange('position', value );
	}

	setSideAdFilter(value) {
		this.setState({
			...this.state,
			filters: {
				...this.state.filters,
				sideAdPosition: value
			}
		}, () => {
			this.filterResults();
		});

		// this.props.handleFilterChange('position', value );
	}

	setUniquelyLinkedFilter(value) {
		this.setState({
			...this.state,
			filters: {
				...this.state.filters,
				uniquelyLinked: value
			}
		}, () => {
			this.filterResults();
		});

		// this.props.handleFilterChange('position', value );
	}

	setCampaignsFilter(value) {
		this.setState({
			...this.state,
			filters: {
				...this.state.filters,
				campaigns: value
			}
		}, () => {
			this.filterResults();
		});
	}

	setStartDateFilter(event, date) {
		this.setState({
			...this.state,
			filters: {
				...this.state.filters,
				startDate: date
			}
		}, () => {
			this.filterResults();
		});
	}

	setEndDateFilter(event, date) {
		this.setState({
			...this.state,
			filters: {
				...this.state.filters,
				endDate: date
			}
		}, () => {
			this.filterResults();
		});
	}

	setActiveFilter(value) {
		this.setState({
			...this.state,
			filters: {
				...this.state.filters,
				active: value
			}
		}, () => {
			this.filterResults();
		});
	}

	setTypeFilter(value) {
		this.setState({
			...this.state,
			filters: {
				...this.state.filters,
				type: value
			}
		}, () => {
			this.filterResults();
		});
	}

	setSubjectFilter(value) {
		this.setState({
			...this.state,
			filters: {
				...this.state.filters,
				subject: value
			}
		}, () => {
			this.filterResults();
		});
	}

	setDepartmentFilter(value) {
		this.setState({
			...this.state,
			filters: {
				...this.state.filters,
				department: value
			}
		}, () => {
			this.filterResults();
		});
	}

	setCompanyFilter(value) {
		this.setState({
			...this.state,
			filters: {
				...this.state.filters,
				company: value
			}
		}, () => {
			this.filterResults();
		});
	}

	filterOnPosition() {
		if (null !== this.state.filters.position) {
			this.setState({
				promotionsToShow: [
					...this.state.promotionsToShow.filter((promotion) => {
						return promotion.position === this.state.filters.position.value
					})
				]
			})
		}

		Promise.resolve();
	}

	filterOnUniquelyLinked() {
		if (null !== this.state.filters.uniquelyLinked) {
			this.setState({
				promotionsToShow: [
					...this.state.promotionsToShow.filter((promotion) => {
						return promotion.uniquelyLinked === this.state.filters.uniquelyLinked.value
					})
				]
			})
		}

		Promise.resolve();
	}

	filterOnCampaign() {
		if (null !== this.state.filters.campaigns && this.state.filters.campaigns.length > 0) {
			this.setState({
				promotionsToShow: [
					...this.state.promotionsToShow.filter((promotion) => {

						const campaign = this.state.filters.campaigns.find((campaign) => {
							return promotion.campaignKey === campaign.value;
						});

						return undefined !== campaign;
					})
				]
			})
		}

		Promise.resolve();
	}

	filterOnPostID() {
		if (this.state.filters.postIds.ID) {


			this.setState({
				promotionsToShow: [
					...this.state.promotionsToShow.filter(promotion => {
						const found = promotion.linkedTo.find( post => {
							return parseInt( post.ID ) === parseInt( this.state.filters.postIds.ID )
						});

						return !!found;
					})
				]
			});
		}

		Promise.resolve();
	}

	filterOnDate() {
		if (null !== this.state.filters.endDate || null !== this.state.filters.startDate) {
			let isActive = false;

			this.setState({
				promotionsToShow: [
					...this.state.promotionsToShow.filter((promotion) => {

						if (promotion.position === 'branded') {

							if (null !== this.state.filters.startDate && null === this.state.filters.endDate) {
								return (
									(this.state.filters.startDate <= promotion.end || this.state.filters.startDate <= promotion.start)
								);
							} else if (null === this.state.filters.startDate && null !== this.state.filters.endDate) {
								return (
									(this.state.filters.endDate >= promotion.end || this.state.filters.endDate >= promotion.start)
								)
							} else {
								return (
									(this.state.filters.startDate >= promotion.start && this.state.filters.startDate <= promotion.end) &&
									(this.state.filters.endDate <= promotion.start && this.state.filters.startDate <= promotion.end)
								);
							}
						} else {
							let startDateTimestamp = 0;
							let endDateTimestamp = 0;

							if (null !== this.state.filters.startDate) {
								const startDate = new Date(JSON.parse(JSON.stringify(this.state.filters.startDate)));

								let timeZoneOffset = startDate.getTimezoneOffset() / 60;
								const hours = startDate.getHours();

								if (timeZoneOffset < 0) {
									timeZoneOffset = Math.abs(timeZoneOffset);
								}

								startDate.setHours(hours - timeZoneOffset);
								startDateTimestamp = startDate.getTime();
							}

							if (null !== this.state.filters.endDate) {
								const endDate = new Date(JSON.parse(JSON.stringify(this.state.filters.endDate)));

								let timeZoneOffset = endDate.getTimezoneOffset() / 60;
								const hours = endDate.getHours();

								if (timeZoneOffset < 0) {
									timeZoneOffset = Math.abs(timeZoneOffset);
								}

								endDate.setHours(hours - timeZoneOffset);
								endDateTimestamp = endDate.getTime();
							}

							const period = promotion.periods.find((period) => {
								if (null === this.state.filters.startDate) {
									return (
										period.end <= endDateTimestamp ||
										period.start <= endDateTimestamp
									);
								} else if (null === this.state.filters.endDate) {
									return (
										period.end >= startDateTimestamp ||
										period.start <= startDateTimestamp
									);
								} else if (null !== this.state.filters.startDate && null !== this.state.filters.endDate) {
									return (
										(period.start <= startDateTimestamp && period.end === 0) ||
										(period.start >= startDateTimestamp && period.start <= endDateTimestamp) ||
										(period.end >= startDateTimestamp && (period.end && period.end <= endDateTimestamp)) ||
										(period.start >= startDateTimestamp && (period.end && period.end <= endDateTimestamp)) ||
										(period.start <= startDateTimestamp && period.end >= endDateTimestamp)
									)
								}
							});

							return undefined !== period;
						}
					})
				]
			})
		}

		Promise.resolve();
	}

	filterOnActive() {
		if (null !== this.state.filters.active) {
			this.setState({
				promotionsToShow: [
					...this.state.promotionsToShow.filter((promotion) => {

						return promotion.active === this.state.filters.active.value;
					})
				]
			})
		}

		Promise.resolve();
	}

	filterOnType() {
		if (null !== this.state.filters.type) {
			this.setState({
				promotionsToShow: [
					...this.state.promotionsToShow.filter((promotion) => {

						return promotion.campaignTypeKey === this.state.filters.type.value;
					})
				]
			})
		}

		Promise.resolve();
	}

	filterOnSubject() {
		if (null !== this.state.filters.subject) {
			this.setState({
				promotionsToShow: [
					...this.state.promotionsToShow.filter((promotion) => {
						return promotion.campaignSubjectKey === this.state.filters.subject.value;
					})
				]
			})
		}

		Promise.resolve();
	}

	filterOnSideAdPosition() {
		if (null !== this.state.filters.sideAdPosition) {
			this.setState({
				promotionsToShow: [
					...this.state.promotionsToShow.filter((promotion) => {
						return promotion.sideAdPosition === this.state.filters.sideAdPosition.value;
					})
				]
			})
		}

		Promise.resolve();

	}

	filterOnDepartment() {
		if (null !== this.state.filters.department) {
			this.setState({
				promotionsToShow: [
					...this.state.promotionsToShow.filter((promotion) => {
						return promotion.campaignDepartmentKey === this.state.filters.department.value;
					})
				]
			})
		}

		Promise.resolve();
	}

	filterOnCompany() {
		if (null !== this.state.filters.company) {
			this.setState({
				promotionsToShow: [
					...this.state.promotionsToShow.filter((promotion) => {
						return promotion.campaignCompanyKey === this.state.filters.company.value;
					})
				]
			})
		}

		Promise.resolve();
	}

	downloadCsv() {
		this.setState({
			downloadingCsv        : true,
			csvData               : [],
			downloadingCsvProgress: 0,
		}, () => {
			this.getCsvData();
		})
	}

	closeDialog() {
		this.setState({
			downloadingCsv: false,
			csvData       : []
		})
	}

	shouldShow(column) {
		const col = this.state.userSettings.columns.find(col => col.name === column);

		if (undefined !== col) {
			return col.show;
		}

		return true;
	}

	archivePromotion(event, promotion) {
		event.persist();
		event.preventDefault();
		app.database().ref('/cams/promotions/promotions').child(promotion.key).update({
			archived: this.props.match.params.type !== 'archived'
		}, (error) => {
			const parent = event.target.closest('tr');

			parent.classList.add('promotion__data__row--hidden');
		})
	}

	async duplicatePromotion(event, promotion) {
		event.persist();
		event.preventDefault();

		api.overlay.showOverlay('Momentje, ik ben de promotie aan het dupliceren.');

		let newPromotion = await getPromotion(promotion.key);

		newPromotion = await api.promotions.cleanPromotion(newPromotion);
		newPromotion.name = newPromotion.name + ' [DUPLICAAT]';
		newPromotion.isActive = false;

		api.promotions.setNewPromotion(newPromotion)
			.then(async () => {
				let promotionID = await api.promotions.create();

				return promotionID;
			}).then(promotionID => {
			api.overlay.hideOverlay();

			this.props.history.push(`/app/promotions/promotion/${promotionID}`);
		});
	}

	render() {
		const headers = [
			{label: 'Actief', key: 'active'},
			{label: 'Promotie', key: 'name'},
			{label: 'Campagne', key: 'campaign'},
			{label: 'Type', key: 'type'},
			{label: 'Onderwerp', key: 'subject'},
			{label: 'Opdrachtgever', key: 'department'},
			{label: 'Positie', key: 'position'},
			{label: 'Views', key: 'views'},
			{label: 'Clicks', key: 'clicks'},
			{label: 'CTR%', key: 'ctr'},
		];

		return (
			<AppContentComponent>
				<h1>Vergelijk op kenmerk</h1>
				{/*<AppStatisticsCompareFiltersComponent filters={this.state.filters} promotions={this.state.promotions} handleFilterChangeArray={this.handleFilterChangeArray} handleFilterChange={this.handleFilterChange} />*/}
				{/*<AppStatisticsCompareTableComponent filters={this.state.filters} promotions={this.state.promotions} csvData={this.state.csvData} />*/}

				<div className="grid-x grid-padding-x">
					<div className="medium-12 cell">
						<div className="grid-x grid-margin-x">
							<div className="medium-3 small-12 cell">
								<label>Positie</label>
								<Select
									options={this.state.filterOptions.positions}
									onChange={this.setPositionFilter}
									value={this.state.filters.position}
									placeholder="Positie"
								/>
							</div>
							<div className="medium-3 small-12 cell">
								<label>Campagne</label>
								<Select
									options={this.state.filterOptions.campaigns}
									onChange={this.setCampaignsFilter}
									value={this.state.filters.campaigns}
									placeholder="Campagne"
									multi={true}
								/>
							</div>
							<div className="medium-3 small-12 cell">
								<label>Startdatum</label>
								<DatePicker
									hintText="Startdatum"
									value={this.state.filters.startDate}
									onChange={this.setStartDateFilter}
									fullWidth={true}
								/>
							</div>
							<div className="medium-3 small-12 cell">
								<label>Einddatum</label>
								<DatePicker
									hintText="Einddatum"
									value={this.state.filters.endDate}
									onChange={this.setEndDateFilter}
									fullWidth={true}
								/>
							</div>
						</div>
						<div className="grid-x grid-margin-x" style={{marginBottom: '10px'}}>
							<div className="medium-3 small-12 cell">
								<label>Actief / Niet actief</label>
								<Select
									options={this.state.filterOptions.active}
									onChange={this.setActiveFilter}
									value={this.state.filters.active}
									placeholder="Actief / Niet actief"
								/>
							</div>
							<div className="medium-3 small-12 cell">
								<label>Type</label>
								<Select
									options={this.state.filterOptions.types}
									onChange={this.setTypeFilter}
									value={this.state.filters.type}
									placeholder="Type"
								/>
							</div>
							<div className="medium-3 small-12 cell">
								<label>Waarover</label>
								<Select
									options={this.state.filterOptions.subjects}
									onChange={this.setSubjectFilter}
									value={this.state.filters.subject}
									placeholder="Waarover"
								/>
							</div>
							<div className="medium-3 small-12 cell">
								<label>Opdrachtgever</label>
								<Select
									options={this.state.filterOptions.departments}
									onChange={this.setDepartmentFilter}
									value={this.state.filters.department}
									placeholder="Opdrachtgever"
								/>
							</div>
						</div>
						<div className="grid-x grid-margin-x" style={{marginBottom: '40px'}}>
							<div className="medium-3 small-12 cell">
								<label>Bedrijfsnaam</label>
								<Select
									options={this.state.filterOptions.companies}
									onChange={this.setCompanyFilter}
									value={this.state.filters.company}
									placeholder="Bedrijfsnaam"
								/>
							</div>
							<div className="medium-3 small-12 cell">
								<label>Kantlijn Positie</label>
								<Select
									options={this.state.filterOptions.sideAdPositions}
									onChange={this.setSideAdFilter}
									value={this.state.filters.sideAdPosition}
									placeholder="Kantlijn positie"
								/>
							</div>
							<div className="medium-3 small-12 cell">
								<label>Uniek gekoppeld?</label>
								<Select
									options={this.state.filterOptions.uniquelyLinked}
									onChange={this.setUniquelyLinkedFilter}
									value={this.state.filters.uniquelyLinked}
									placeholder="Uniek gekoppeld"
								/>
							</div>

							<div className="medium-3 small-12 cell">
								<label>Gekoppeld aan artikel</label>
								<Select.Async
									multi={false}
									valueKey="ID"
									labelKey="post_title"
									loadOptions={this.getPosts}
									value={this.state.filters.postIds}
									onChange={this.setPostIds}
									isLoading={this.state.isLoadingPosts}
								/>
							</div>

						</div>
						{/*<RaisedButton*/}
						{/*label="Meer filters"*/}
						{/*primary={true}*/}
						{/*/>*/}
					</div>
				</div>

				<div className="grid-x grid-padding-x" style={{marginBottom: '10px'}}>
					<div className="medium-12 cell text-right">
						<RaisedButton
							label="Download CSV"
							primary={true}
							onClick={this.downloadCsv}
						/>
					</div>
				</div>

				<div className="table-scroll">
					<table>
						<thead>
						<tr>
							<th>Active</th>
							<th>Promotie</th>
							{this.shouldShow('campaign') &&
							<th>Campagne</th>
							}
							{this.shouldShow('type') &&
							<th>Type</th>
							}
							{this.shouldShow('about') &&
							<th>Waarover</th>
							}
							{this.shouldShow('department') &&
							<th>Opdrachtgever</th>
							}
							<th>Bedrijf</th>
							{this.shouldShow('type') &&
							<th>Positie</th>
							}
							{this.shouldShow('views') &&
							<th>Views</th>
							}
							{this.shouldShow('clicks') &&
							<th>Clicks</th>
							}
							{this.shouldShow('ctr') &&
							<th>CTR</th>
							}
							{this.shouldShow('promotionIds') &&
							<td>Promotie ID</td>
							}
							{this.shouldShow('variantIds') &&
							<td>Variant ID's</td>
							}



						</tr>
						</thead>
						<tbody className={'promotion__data'}>
						{
							this.state.promotionsToShow.map((promotion, index) => {
								const promotionLink = '/app/promotions/promotion/' + promotion.key;

								return (
									<tr className={'promotion__data__row'} height="67" valign="top" key={promotion.key} onClick={() => this.loadPromotionStatistics(promotion)}>
										<td>
											<div className={`promotion__status promotion__status--${promotion.status}`}></div>
										</td>
										<td>
											<Link to={promotionLink}>{promotion.name}</Link>
											<div className={'promotion__actions'}>
												<a onClick={(event) => this.archivePromotion(event, promotion)}>{this.props.match.params.type !== 'archived' ? 'Archiveer' : 'Dearchiveer'}</a>
												<a onClick={(event) => this.duplicatePromotion(event, promotion)}>Dupliceer</a>
											</div>
										</td>
										{this.shouldShow('campaign') &&
										<td>{promotion.campaignName}</td>
										}
										{this.shouldShow('type') &&
										<td>{promotion.campaignType}</td>
										}
										{this.shouldShow('about') &&
										<td>{promotion.campaignSubject}</td>
										}
										{this.shouldShow('department') &&
										<td>{promotion.campaignDepartment}</td>
										}
										<td>{promotion.campaignCompany}</td>
										{this.shouldShow('type') &&
										<td>{promotion.promotionType}</td>
										}
										{this.shouldShow('views') &&
										<td>{promotion.views}</td>
										}
										{this.shouldShow('clicks') &&
										<td>{promotion.clicks}</td>
										}
										{this.shouldShow('ctr') &&
										<td>{promotion.ctr}%</td>
										}
										{this.shouldShow('promotionIds') &&
										<td>
											{promotion.key}
										</td>
										}
										{this.shouldShow('variantIds') &&
										<td>
											{promotion.variants && promotion.variants.map( ( variant, key ) => ( <div key={key}>{variant.key}</div> ))}
										</td>
										}
									</tr>
								)
							})
						}
						</tbody>
					</table>
				</div>
				<div className="grid-x grid-padding-x">
					<div className="medium-12 cell text-right">
						<RaisedButton
							label="Download CSV"
							primary={true}
							onClick={this.downloadCsv}
						/>
					</div>
				</div>

				<Dialog
					open={this.state.downloadingCsv}
				>
					{this.state.downloadingCsvProgress < 100 &&
					<div>
						<p style={{marginBottom: '20px'}}>De data voor de export wordt opgehaald</p>
						<LinearProgress mode="determinate" value={this.state.downloadingCsvProgress} />
					</div>
					}

					{this.state.downloadingCsvProgress >= 100 &&
					<div>
						<p style={{marginBottom: '20px'}}>Klik op "Download CSV" om de CSV te downloaden</p>
						<CSVLink
							data={this.state.csvData}
							headers={headers}
							separator={";"}
							className="button primary"
							filename={"cams-stats.csv"}
						>
							Download CSV
						</CSVLink>
						<RaisedButton
							label="Sluiten"
							primary={false}
							onClick={this.closeDialog}
						/>

					</div>
					}
				</Dialog>
			</AppContentComponent>
		)
	}
}

const styles = {
	hidden: {
		display: 'none'
	}
};

const mapStateToProps = (state) => {
	return {
		user: state.auth.user
	}
};

export default withRouter(connect(mapStateToProps)(AppStatisticsCompareComponent))



// WEBPACK FOOTER //
// ./src/application/components/statistics/components/compare.js